import { useEffect, useRef } from 'react'
import { isRef, runIfFn } from '../assertion'

function on(obj, ...args) {
  if (obj && obj.addEventListener) {
    obj.addEventListener(...args)
  }
}

function off(obj, ...args) {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(...args)
  }
}

function isListenerType1(target) {
  return Boolean(target.addEventListener)
}

function isListenerType2(target) {
  return Boolean(target.on)
}

export const useEventListener = (name, handler, target, options = {}) => {
  const { enabled = true, ...restOptions } = options
  const savedHandler = useRef()

  useEffect(() => {
    if (!enabled) return

    savedHandler.current = handler
  }, [enabled, handler])

  useEffect(() => {
    if (!enabled) return

    const element = isRef(target) ? target.current : runIfFn(target) ?? window

    if (!element) return

    const eventListener = event => {
      if (savedHandler?.current) {
        savedHandler.current(event)
      }
    }

    if (isListenerType1(element)) {
      on(element, name, eventListener, restOptions)
    } else if (isListenerType2(element)) {
      element.on(name, eventListener, restOptions)
    }

    return () => {
      if (isListenerType1(element)) {
        off(element, name, eventListener, restOptions)
      } else if (isListenerType2(element)) {
        element.off(name, eventListener, restOptions)
      }
    }
  }, [enabled, name, target, restOptions])
}
